module.exports = __webpack_public_path__ + "fonts/nunito-sans-v11-latin-800.8ef69d7d.woff";